import React, { useEffect, useRef } from 'react';

export function ConfirmDialog({
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  tone = 'default',
  onConfirm,
  onCancel,
}) {
  const cardRef = useRef(null);
  const cancelBtnRef = useRef(null);
  const previousFocus = useRef(null);

  useEffect(() => {
    previousFocus.current = document.activeElement;
    const t = setTimeout(() => {
      if (cancelBtnRef.current) cancelBtnRef.current.focus();
    }, 0);

    const onKey = (e) => {
      if (e.key === 'Escape') {
        e.stopPropagation();
        onCancel();
      }
    };
    document.addEventListener('keydown', onKey);

    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      clearTimeout(t);
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prevOverflow;
      if (previousFocus.current && typeof previousFocus.current.focus === 'function') {
        previousFocus.current.focus();
      }
    };
  }, [onCancel]);

  const titleId = 'lr-fb-confirm-title';
  const descId = 'lr-fb-confirm-desc';

  return (
    <div
      className="lr-fb-backdrop"
      onClick={onCancel}
      data-testid="feedback-confirm"
    >
      <div
        ref={cardRef}
        className="lr-fb-card"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby={titleId}
        aria-describedby={descId}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="lr-fb-hdr">
          <div id={titleId} className={`lr-fb-title${tone === 'danger' ? ' danger' : ''}`}>
            {title}
          </div>
        </div>
        <div id={descId} className="lr-fb-body">
          {typeof message === 'string' ? <p style={{ margin: 0 }}>{message}</p> : message}
        </div>
        <div className="lr-fb-footer">
          <button
            ref={cancelBtnRef}
            type="button"
            className="lr-fb-btn lr-fb-btn-cancel"
            onClick={onCancel}
            data-testid="feedback-confirm-cancel"
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            className={`lr-fb-btn lr-fb-btn-confirm${tone === 'danger' ? ' danger' : ''}`}
            onClick={onConfirm}
            data-testid="feedback-confirm-accept"
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
